export default [
  {
    path: '/admin/practitioners',
    name: 'admin-practitioners',
    component: () => import('@/views/apps/admin/AdminPractitioners.vue'),
    meta: {
      resource: 'AdminPractitioners',
      action: 'read',
    },
  },
  {
    path: '/apps/calendar',
    name: 'apps-calendar',
    component: () => import('@/views/apps/calendar/Calendar.vue'),
    meta: {
      resource: 'Calendar',
      action: 'read',
    },
  },
  {
    path: '/apps/chat',
    name: 'apps-chat',
    redirect: { name: 'dashboard' },
    meta: {
      resource: 'Chat',
      action: 'read',
      contentRenderer: 'sidebar-left',
      contentClass: 'chat-application',
    },
  },
  {
    path: '/apps/todo',
    name: 'apps-todo',
    component: () => import('@/views/apps/note/Note.vue'),
    meta: {
      resource: 'Todo',
      action: 'read',
      contentRenderer: 'sidebar-left',
      contentClass: 'todo-application',
    },
  },
  {
    path: '/app/apps/:id/todo/',
    name: 'apps-todo-user',
    component: () => import('@/views/apps/note/Note.vue'),
    meta: {
      resource: 'TodoID',
      action: 'read',
      contentRenderer: 'sidebar-left',
      contentClass: 'todo-application',
    },
  },
  // *===============================================---*
  // *--------- USER ---- ---------------------------------------*
  // *===============================================---*
  {
    path: '/apps/users/list',
    name: 'apps-users-list',
    component: () => import('@/views/apps/user/users-list/UsersList.vue'),
    meta: {
      resource: 'UsersList',
      action: 'read',
    },
  },
  {
    path: '/apps/users/view/:id',
    name: 'apps-users-view',
    component: () => import('@/views/apps/user/users-view/UsersView.vue'),
    meta: {
      resource: 'UsersView',
      action: 'read',
    },
  },
  {
    path: '/apps/users/edit/:id',
    name: 'apps-users-edit',
    component: () => import('@/views/apps/user/users-edit/UsersEdit.vue'),
    meta: {
      resource: 'UsersEdit',
      action: 'read',
    },
  },
  {
    path: '/apps/restaurants',
    name: 'apps-restaurants',
    component: () => import('@/views/apps/restaurant/Restaurants.vue'),
    meta: {
      resource: 'PractitionerMenu',
      action: 'read',
    },
  },

  // Invoice
  {
    path: '/apps/invoice/list',
    name: 'apps-invoice-list',
    component: () => import('@/views/apps/invoice/invoice-list/InvoiceList.vue'),
  },

  // *===============================================---*
  // *--------- NOTE ---------------------------------------*
  // *===============================================---*
  {
    path: '/apps/note',
    name: 'apps-note',
    component: () => import('@/views/apps/note/Note.vue'),
    meta: {
      resource: 'Note',
      action: 'read',
      contentRenderer: 'sidebar-left',
      contentClass: 'todo-application',
    },
  },
  {
    path: '/apps/:id/note',
    name: 'apps-note-user',
    component: () => import('@/views/apps/note/Note.vue'),
    meta: {
      resource: 'NoteID',
      action: 'read',
      contentRenderer: 'sidebar-left',
      contentClass: 'todo-application',
    },
  },

]
